import {
  DenseTable,
  DenseTableProps,
  TitledSection,
  TitledSectionProps
} from '.'

interface TitledTableProps<RowDataType>
  extends Pick<TitledSectionProps, 'translationid'> {
  tableProps: DenseTableProps<RowDataType>
}

export const TitledTable = <RowDataType,>({
  translationid,
  tableProps
}: TitledTableProps<RowDataType>) => {
  return (
    <TitledSection translationid={translationid}>
      <DenseTable {...tableProps} />
    </TitledSection>
  )
}
